export function isFilesystemRootDirectory(directory: string) {
  const normalized = directory.trim().replace(/\\/g, "/").replace(/\/+$/, "")
  return normalized === "" || normalized === "/" || /^[A-Za-z]:$/.test(normalized)
}
